import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function Leverantor(props) {
    const classes = useStyles();
    const [leverantor, setleverantor] = React.useState(props.leverantor);
    React.useEffect(()=>{
        setleverantor(props.leverantor)
    },[props.leverantor])
    React.useEffect(()=>{
        let HasLeve= props.AvtalTyplist.filter(item=>{
          return item.type === props.OrderType
        })[0].defaultOperator

        
        //
        let OpValue = isEmpty(props.Options)?"":props.Options.filter(item=>{return item.id === HasLeve})
        console.log(OpValue,12222)
        //
        setleverantor(isEmpty(props.Options)?"":isEmpty(OpValue)?"":OpValue[0].operator)
        props.selectedthisAvtalLeverantor({
            target:{
                value:isEmpty(props.Options)?"":isEmpty(OpValue)?"":OpValue[0].operator,
                name:"leverantor"
            }
        })
    },[props.OrderType])
   
    return (
        <form className={classes.root}>
            <div className="mt-1">
            <TextField
                    select={isEmpty(props.Options)?false:true}
                    label={<IntlMessages id="Supplier"/>}
                    variant="outlined"
                    name="leverantor"
                    size="small"
                    value={leverantor}
                    fullWidth
                    onChange={props.selectedthisAvtalLeverantor}
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{
                        shrink: true,
                      }}
                >
                    {
                        isEmpty(props.Options)?"":
                        <>
                    <option key="" value={""} disabled selected>
                            Välj
                    </option>
                    {props.Options.map((option) => (
                        <option key={option.id} value={option.operator}>
                            {option.operator}
                        </option>
                    ))}    
                        </>
                    }
                    
                </TextField>
            </div>
        </form>
    );
}

export default Leverantor;